module.exports = __webpack_public_path__ + "static/media/myphoto8.90e3f248.JPG";